module.exports = __webpack_public_path__ + "static/2-896061c571a81355019e0f3e3cc6b9b5.jpg";